import {WishlistStreamItem} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/stream.types';

export function getWishlistItemProductId(
  item: WishlistStreamItem,
): number | undefined {
  if (item.type?.$case === 'product') {
    return item.type.product.product.productId;
  }
  if (item.type?.$case === 'soldoutProduct') {
    return item.type.soldoutProduct.soldoutProduct.productId;
  }
  return undefined;
}
